import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';

const API_URL = import.meta.env.VITE_API_URL || '/api';
const getAuthToken = () => typeof window !== 'undefined' ? localStorage.getItem('authToken') : null;

export default function SocialProofNudge() {
  const [data, setData] = useState<{ friendsPostedToday: number; friendNames: string[]; friendAvatars: string[] } | null>(null);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;
    fetch(`${API_URL}/engagement/social-proof`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.ok ? r.json() : null)
      .then(d => { if (d && d.friendsPostedToday > 0) setData(d); })
      .catch(() => {});
  }, []);

  if (!data) return null;

  const names = data.friendNames;
  let text: string;
  if (names.length === 1) text = `${names[0]} posted today`;
  else if (names.length === 2) text = `${names[0]} and ${names[1]} posted today`;
  else text = `${names[0]}, ${names[1]}, and ${data.friendsPostedToday - 2} other${data.friendsPostedToday - 2 > 1 ? 's' : ''} posted today`;

  return (
    <div className="flex items-center gap-2.5 px-4 py-2.5 mb-3 rounded-xl bg-iris-500/6 border border-iris-500/15">
      {data.friendAvatars.length > 0 && (
        <div className="flex -space-x-2">
          {data.friendAvatars.map((url, i) => (
            <img
              key={i}
              src={url}
              alt=""
              className="w-6 h-6 rounded-full border-2 border-[#16161e] object-cover"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
          ))}
        </div>
      )}
      {data.friendAvatars.length === 0 && (
        <Users size={14} className="text-iris-400 shrink-0" />
      )}
      <span className="text-xs text-iris-300/80">{text}</span>
    </div>
  );
}
